import { Box, Avatar, Flex, Text } from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLanguageContext } from '../../../context/locale.context'
import { getTimeFromNow } from '../../../utils/date.utils'
import { useSharedContext } from '../../../context/shared.context'
import { ParticipantMenu } from './participantMenu'
import { useAuthContext } from './../../../context/auth.context'
import ButtonCTA from './../button/index'

const ActivityUsersRow = ({
	user,
	userType,
	participantData,
	setOwner,
	setLead,
	removeParticipant,
	inviteUser,
	selectedType,
}) => {
	const {
		operating_asset_first_name,
		asset_type_name,
		asset_datetime_last_seen,
		activity_creator_asset_id,
		asset_id,
		contact_phone_country_code: countryCode,
		contact_phone_number: phoneNumber,
		asset_flag_is_owner,
	} = user

	const {
		state: { activity, activityTypeDetails },
	} = useSharedContext()

	const {
		state: {
			authData: { asset_id: loggedInuserId },
		},
	} = useAuthContext()

	const {
		state: { locale },
	} = useLanguageContext()

	const { activity_lead_asset_id: leadAssetId } = activity

	const [timePassed, setTimePassed] = useState(
		getTimeFromNow(asset_datetime_last_seen)
	)

	const mutateParticipants = {
		setOwner: () => setOwner(user),
		removeOwner: () => setOwner(user, false),
		setLead: () => setLead(user),
		removeParticipant: () => removeParticipant(user),
	}

	const ownerList = participantData
		? (participantData.list || [])
				.map(u => !!u.asset_flag_is_owner && u.asset_id)
				.filter(Boolean)
		: []

	const activityAccess = {
		isCreator: activity_creator_asset_id === asset_id,
		islead: leadAssetId === asset_id,
		arpLeadSettingEnabled:
			activityTypeDetails?.activity_type_arp_lead_setting_enabled === 1 &&
			leadAssetId !== asset_id,
		isOwner: asset_flag_is_owner,
		canHaveRemoveAccess: [
			activity_creator_asset_id,
			leadAssetId,
			...ownerList,
		].includes(loggedInuserId),
		isLoggedInUserCreator: activity_creator_asset_id === loggedInuserId,
	}

	useEffect(() => {
		const interval_time = 1000
		// Setting time passed every 1 second, otherwise too many rerenders happening
		const timePassedInterval = setInterval(
			() => setTimePassed(getTimeFromNow(asset_datetime_last_seen)),
			interval_time
		)

		return () => clearInterval(timePassedInterval)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const renderMenu = () => {
		if (userType === 'participant')
			return (
				<ParticipantMenu
					participantData={participantData}
					activityAccess={activityAccess}
					mutateParticipants={mutateParticipants}
				/>
			)
		if (userType === 'team')
			return (
				<ButtonCTA
					alignSelf='center'
					variant='idcardButton'
					size='sm'
					fontSize='12px'
					fontWeight='900'
					bg='white'
					mt='0px'
					ml='auto'
					textTransform='uppercase'
					onClick={() => {
						inviteUser(user)
					}}
				>
					{locale['Invite']}
				</ButtonCTA>
			)
	}

	return (
		<Box p='1rem'>
			<Flex gap='1rem' alignItems='center'>
				<Avatar
					name={operating_asset_first_name.trim()}
					color='white'
					bg='brand.700'
					size='md'
				/>
				<Flex flexDirection='column'>
					<Flex gap='0.75rem'>
						<Text fontSize='1rem' fontWeight='500' textTransform='capitalize'>
							{operating_asset_first_name}
						</Text>
						{!!activityAccess.isCreator && (
							<Flex
								background='yellow.600'
								borderRadius='1rem'
								alignItems='center'
								padding='3px 10px'
							>
								<Text fontSize='0.625rem'>{locale['Creator']}</Text>
							</Flex>
						)}
						{!!activityAccess.islead && (
							<Flex
								background='yellow.600'
								borderRadius='1rem'
								alignItems='center'
								padding='3px 10px'
							>
								<Text fontSize='0.625rem'>{locale['Lead']}</Text>
							</Flex>
						)}
						{!!activityAccess.isOwner && (
							<Flex
								background='yellow.600'
								borderRadius='1rem'
								alignItems='center'
								padding='3px 10px'
							>
								<Text fontSize='0.625rem'>{locale['Owner']}</Text>
							</Flex>
						)}
					</Flex>
					<Text
						color='gray.400'
						fontSize='0.875rem'
						fontWeight='400'
						textAlign='left'
					>
						{asset_type_name}
					</Text>
					<Text
						fontSize='0.75rem'
						fontWeight='400'
						textAlign='left'
						color='#808080'
					>
						{userType === 'participant'
							? `${locale['Last seen'] || 'Last seen'} - ${timePassed}`
							: `+${countryCode} ${phoneNumber}`}
					</Text>
				</Flex>
				{renderMenu()}
			</Flex>
		</Box>
	)
}

ActivityUsersRow.propTypes = {
	user: PropTypes.object.isRequired,
	userType: PropTypes.oneOf(['participant', 'team']).isRequired,
	participantData: PropTypes.object,
	setOwner: PropTypes.func,
	setLead: PropTypes.func,
	removeParticipant: PropTypes.func,
	inviteUser: PropTypes.func,
}

export { ActivityUsersRow }
